import React from 'react';
import { Globe, ChevronDown, Check } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { useLanguage } from '../context/LanguageContext';

const LABELS = { it: 'Italiano', de: 'Deutsch', en: 'English' };

export const LanguageSelector = ({ isScrolled = false, compact = false }) => {
  const { language, setLanguage, LANGUAGES } = useLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid={compact ? 'language-selector-mobile' : 'language-selector'}
          aria-label="Language"
          className={`flex items-center gap-2 rounded-full border transition-all duration-300 outline-none ${
            compact ? 'px-2.5 py-1.5 border-white/30 text-white' : 'px-3 py-2'
          } ${
            !compact && (isScrolled
              ? 'border-white/30 text-white hover:border-[#c9a227] hover:text-[#c9a227]'
              : 'border-white/40 text-white hover:border-[#e8d48b] hover:text-[#e8d48b]')
          }`}
        >
          <Globe size={compact ? 18 : 16} />
          <span className="text-sm font-medium">{language.toUpperCase()}</span>
          <ChevronDown size={14} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[10rem] bg-[#2a1a0f] border border-[#c9a227]/30 text-white z-[60]">
        {LANGUAGES.map((code) => (
          <DropdownMenuItem
            key={code}
            onClick={() => setLanguage(code)}
            data-testid={`language-option-${code}`}
            className="flex items-center justify-between gap-4 cursor-pointer focus:bg-[#c9a227]/20 focus:text-[#e8d48b]"
          >
            <span>
              <span className="font-semibold mr-2">{code.toUpperCase()}</span>
              <span className="text-white/70">{LABELS[code]}</span>
            </span>
            {code === language && <Check size={14} className="text-[#c9a227]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
